import React, { Suspense } from 'react';
import ReactModal from 'react-modal';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Normalise from './shared/styled/Normalise';
import PrivateRoute from './PrivateRoute';
import AppLayout from './AppLayout';
import LayoutFindOrder from './find/LayoutFindOrder';
import ScrollToTop from './ScrollToTop';

const LayoutProducts = React.lazy(() => import('./products/LayoutProducts'));
const LayoutSummary = React.lazy(() => import('./summary/LayoutSummary'));
const LayoutComplete = React.lazy(() => import('./complete/LayoutComplete'));
const LayoutPickMethod = React.lazy(() => import('./pickup/LayoutPickMethod'));
const AppNotFound = React.lazy(() => import('./AppNotFound'));

ReactModal.setAppElement('#root');

const AppRoutes = () => (
  <Router>
    <ScrollToTop>
      <main data-version={process.env.REACT_APP_VERSION}>
        <Normalise />
        <AppLayout>
          <Switch>
            <Route
              strict
              exact
              path="/:merchantReference"
              component={LayoutFindOrder}
            />
            <PrivateRoute
              exact
              path="/:merchantReference/order"
              component={LayoutProducts}
            />
            <PrivateRoute
              exact
              path="/:merchantReference/summary"
              component={LayoutSummary}
            />
            <PrivateRoute
              exact
              path="/:merchantReference/complete"
              component={LayoutComplete}
            />
            <PrivateRoute
              exact
              path="/:merchantReference/methods"
              component={LayoutPickMethod}
            />
            <Route
              render={() => (
                <Suspense fallback={<div />}>
                  <AppNotFound />
                </Suspense>
              )}
            />
          </Switch>
        </AppLayout>
      </main>
    </ScrollToTop>
  </Router>
);

export default AppRoutes;
